






























import Vue from 'vue'
import { debounce } from 'lodash'
import helpers from '@/helpers'
export default Vue.extend({
  name: 'IosWrapper',
  data: () => ({
    style: {} as Partial<CSSStyleDeclaration>
  }),
  created () {
    this.$store.direct.dispatch.events.setIosFront()
  },
  mounted () {
    this.calculateStyles()
    window.addEventListener('resize', debounce(this.calculateStyles.bind(this)))
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calculateStyles)
  },
  computed: {
    src (): string {
      const id = this.$route.params.id
      const token = this.$route.query.token
      return helpers.getURL(this.$router, 'iosFront', { id }) + `?token=${ token }`
    }
  },
  methods: {
    calculateStyles (): void {
      const iframe = this.$refs.iframe as HTMLElement|undefined
      if (iframe === undefined) {
        window.setTimeout(this.calculateStyles, 1000)
        return
      }
      const width = 1920
      const height = 1080
      const scale = window.innerWidth / width
      const style: Partial<CSSStyleDeclaration> = {
        width: `${ width }px`,
        height: `${ height }px`,
        pointerEvents: 'none',
        transform: `scale(${ scale })`,
        transformOrigin: '0 0'
      }
      this.style = style
    }
  }
})
